// Una lista de juegos agrupada por fecha, la mas cercana primero y "Sin fecha" al final.
// Es la forma natural de una agenda: "que juego y cuando", sin perillas.
const NOMBRE_DIA = { weekday: 'long', day: 'numeric', month: 'long' }

const etiqueta = (fecha) => {
  if (!fecha) return 'Sin fecha'
  const d = new Date(`${fecha}T00:00:00`)
  if (Number.isNaN(d.getTime())) return fecha
  return d.toLocaleDateString('es-MX', NOMBRE_DIA)
}

export const agruparJuegosPorFecha = (juegos = []) => {
  const grupos = new Map()
  ;(juegos || []).forEach((juego) => {
    if (!juego) return
    const key = juego.fecha || ''
    if (!grupos.has(key)) grupos.set(key, { fecha: key || 'sin-fecha', label: etiqueta(key), juegos: [] })
    grupos.get(key).juegos.push(juego)
  })
  const porHora = (a, b) => (a.hora || '23:59').localeCompare(b.hora || '23:59')
  return Array.from(grupos.values())
    .map((g) => ({ ...g, juegos: [...g.juegos].sort(porHora) }))
    .sort((a, b) => {
      if (a.fecha === 'sin-fecha') return 1
      if (b.fecha === 'sin-fecha') return -1
      return a.fecha.localeCompare(b.fecha)
    })
}
